import { useState } from 'react';
import { track } from '../lib/amplitude';
import { playSound } from '../lib/sounds';
import { soundEffectsPreference } from '../lib/storage';
import { VolumeIcon, VolumeOffIcon } from './icons';
import { Toggle } from './ui';

/**
 * The recorder's sounds, on or off for this browser. Turning them on plays
 * the chime once, so the choice is heard as it is made rather than found out
 * on the next take.
 */
export function SoundEffectsToggle() {
  const [on, setOn] = useState(() => soundEffectsPreference.get());
  return (
    <Toggle
      active={on}
      onChange={() => {
        const next = !on;
        soundEffectsPreference.set(next);
        setOn(next);
        track('Setting Changed', { setting: 'sound_effects', value: next });
        if (next) playSound('done', { force: true });
      }}
      icon={on ? <VolumeIcon /> : <VolumeOffIcon />}
      label="Sound effects"
      hint={on ? 'On' : 'Off'}
    />
  );
}
